<template>
    <div class="page">
        <Header title="确认订单"/>
        <div style="height: 1px"></div>
        <div class="address" @click="showPickerAddress" v-if="address">
            <img class="icon" :src="Images.icon_area" alt="">
            <div>
                <p>{{address.name}}<span>{{address.mobile}}</span></p>
                <span>{{ address.area+' '+address.address }}</span>
            </div>
            <img class="arrow" :src="Images.icon_arrow_right1" alt="">
        </div>
        <div class="address" v-else>
            <div class="address-tips td-f1 td-fcc" @click="onPressNav('address')">
                <span>您还没有设置地址</span>
                <span class="btn">设置地址</span>
            </div>
        </div>
        <div class="goods">
            <p>商品信息</p>
            <div class="item" v-for="(item, index) in goods" :key="index">
                <div class="header">
                    <p>{{item.name}}</p>
                </div>
                <div class="body" v-for="(_item, _index) in item.list" :key="_index">
                    <img :src="_item.image" alt="">
                    <div>
                        <p class="title">{{_item.name}}</p>
                        <p class="unit">规格:{{_item.sku_field_name}}</p>
                        <div class="price">
                            <p>￥{{_item.sku_price}}</p>
                            <span>×{{_item.qty}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div>
                <p>商品小计</p>
                <span>¥{{price}}</span>
            </div>
            <div>
                <p>快递费用</p>
                <span>{{freight}}</span>
            </div>
            <div>
                <p>费用合计</p>
                <span>¥{{(price*1)}}</span>
            </div>
            <div class="textarea noline">
                <p>备注</p>
                <textarea rows="3" cols="20" placeholder="请填写备注" v-model="remark"></textarea>
            </div>
        </div>
        <div class="card">
            <div>
                <p class="title">支付方式</p>
            </div>
            <div v-for="(item,index) in payData" :key="index" :class="{check: payType===item.value}" @click="onPressPayType(item.value)">
                <img :src="item.icon" />
                <p>{{item.name}}</p>
                <div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="footerBox"></div>
        <div class="footer">
            <p>合计：<span>￥{{(price*1)}}</span></p>
            <div @click="_showNoticeAlert">提交订单</div>
        </div>
        <!-- 选择地址 -->
        <!-- 地址选择 -->
        <van-action-sheet v-model="showAddress" title="地址选择" >
            <PickerAddress @success="successPickerAddress"></PickerAddress>
        </van-action-sheet>
    </div>
</template>

<script>
import Header from '@/components/Header';
import PickerAddress from '@/components/PickerAddress'
import {payWayWeiXin, wxPay, aliPay} from '@/utils/wxPay'
import Lockr from 'lockr'

export default {
    components: {
        Header,
        PickerAddress
    },
    data() {
        return {
            showAddress: false,
            payType: payWayWeiXin(),
            remark: '',
            price: 0,
            freight: 0,
            shop_id: "",
            address: null,
            return_path: 'order',
            return_url: 'https://wap.ys141319.com/h5/#/order',
            order_info: {},
            // 支付方式
            payData: [
                {name: '微信支付', icon: this.Images.icon_wechat, value: payWayWeiXin()},
                {name: '支付宝', icon: this.Images.icon_alipay, value: 'alipay'},
                {name: '公对公转账', icon: this.Images.icon_small_change, value: '2b'},
            ]
        };
    },
    created () {
        this.goods = JSON.parse(Lockr.get('goods_str'))
        this.shop_id = this.$route.query.shop_id
    },
    mounted() {
        this.requestFreight();
        this.getPrice();
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        // 选择地址
        showPickerAddress () {
            this.showAddress = true
        },
        // 地址选择回调
        successPickerAddress (res) {
            console.log('地址选择回调', res)
            this.address = res
            this.showAddress = false
        },
        // 获取运费
        async requestFreight() {
            let goods_list = [];
            this.goods.forEach(element => {
                element.list.forEach(_element => {
                    goods_list.push({
                        goods_id: _element.goods_id,
                        sku_field: _element.sku_field,
                        qty: _element.qty,
                    })
                })
            });
            let url = this.API.shop_freight;
            let params = {
                
                goods_list: goods_list,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.freight = result.data.freight_amount
                this.freight_popup = result.data.freight_popup
                this.address = result.data.address
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        getPrice() {
            let price = 0;
            this.goods.forEach(element => {
                element.list.forEach(_element => {
                    price = price + (_element.sku_price * _element.qty)
                })
            })
            this.price = Number(price).toFixed(2)
        },
        // 点击跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },

        _showNoticeAlert() {
            let params = {
                title: '温馨提示',
                messageAlign: 'left',
                className: 'customer-popup',
                message: this.freight_popup,
                confirmButtonText: '确定',
            };
            return this.AlertManager.alert(params).then(() => {
                setTimeout(() => {
                    this.onPressSubmit();
                }, 200);
            });
        },

        // 点击切换支付方式
        onPressPayType(type) {
            this.payType = type
        },
        // 点击提交
        async onPressSubmit() {
            let goods_list = [];
            let cart_ids = []
            this.goods.forEach(element => {
                element.list.forEach(_element => {
                    cart_ids.push(_element.id)
                    goods_list.push({
                        goods_id: _element.goods_id,
                        sku_field: _element.sku_field,
                        qty: _element.qty,
                    })
                })
            });

            if (!this.address) {
                return this.ToastManager('请先设置收货地址');
            }

            let url = this.API.shop_create_order;
            let params = {
                shop_id: this.shop_id,
                remark: this.remark,
                user_name: this.address.name,	
                user_mobile: this.address.mobile,
                user_area: this.address.area,
                user_address: this.address.address,	
                goods_list: goods_list,
                cart_ids: cart_ids.join(','),
                is_preview: 0,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.order_info = result.data
                this.Lockr.rm('goods_str')
                this.shopPayOrder();
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        // 订单的支付
        async shopPayOrder() {
            let url = this.API.shop_pay_order;
            let params = {
                pay_type: this.payType,
                return_url: this.return_url,
                return_path: this.return_path,
                order_no: this.order_info.order_no,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let {need_pay, pay_config} = result.data;
                if (need_pay > 0) {
                    if (this.payType == 'alipay') {
                        aliPay(pay_config);
                    } else {
                        if (this.$isWeiXin()) {
                            wxPay(pay_config,(res)=>{
                                if (res.type == 'success') {
                                    this._showPayResult();
                                }
                            })
                        } else {
                            this._onPressToWeb(pay_config);
                        }
                    }

                } else {
                    this._showPayResult();
                }
            } else {
                this.ToastManager(result.msg);
                setTimeout(() => this._onPressToNavigate('', 'order'), 1000);
            }
        },

        _showPayResult() {
            let params = {
                title: '温馨提示',
                message: this.payType != '2b' ? '恭喜您购买成功，立即查看订单？' : '您的订单已提交，请及时联系您的顾问老师',
            };

            this.AlertManager.confirm(params).then(() => {
                this._onPressToNavigate('', 'order');
            }).catch(() => {
                this._onBack();
            });
        }
    },
};
</script>

<style lang="less" scoped>

.address {
    margin: 10px 15px 0;
    padding: 15px;
    background: #fff;
    display: flex;
    align-items: center;
    
    .icon {
        width: 13px;
        height: 16px;
        object-fit: contain;
    }

    .arrow {
        width: 8px;
        height: 15px;
        object-fit: contain;
    }

    div {
        flex: 1;
        margin: 0 10px;
        display: flex;
        flex-direction: column;

        p {
            margin-bottom: 8px;
            font-size: 15px;
            color: #333;
            font-weight: 500;

            span {
                margin-left: 20px;
            }
        }

        span {
            font-size: 14px;
            color: #333;
        }
    }
    .address-tips{
        font-size: 15px;
        font-weight: 500;
        color: #333;
        .btn{
            margin-top: 10px;
            padding: 6px 20px;
            background: linear-gradient(225deg,#9cb2f4, #6472e8);
            font-size: 13px;
            border-radius: 4px;
            color: #fff;
        }
    }
}

.goods {
    margin: 10px 15px 0;
    padding: 0 10px 10px;
    background: #fff;

    > p {
        padding-top: 10px;
        font-size: 14px;
        color: #333;
    }

    .item {
        border-radius: 10px;
        background: #fff;

        > .header {
            margin: 10px 0 0;
            display: flex;
            align-items: center;

            > p {
                font-size: 16px;
                color: #333;
            }
        }

        > .body {
            margin: 10px 0 0;
            flex: 1;
            display: flex;
            align-items: center;
            border-radius: 3px;

            > img {
                width: 90px;
                height: 90px;
                margin-right: 10px;
                object-fit: cover;
            }

            > div {
                flex: 1;
                height: 90px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    font-size: 16px;
                    color: #333;
                }

                .unit {
                    font-size: 12px;
                    color: #666666;
                }

                .price {
                    display: flex;
                    align-items: center;
                    
                    p {
                        flex: 1;
                        font-size: 14px;
                        color: #EF1400;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    span {
                        font-size: 13px;
                        color: #333;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}

.card {
    margin: 10px 15px 0;
    padding: 0 10px;
    background: #fff;

    > div {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;
        
        p {
            flex: 1;
            height: 50px;
            font-size: 14px;
            color: #666666;
            line-height: 50px;
        }

        span {
            font-size: 14px;
            color: #333;
        }

        .title {
            font-size: 15px;
            color: #333;
            font-weight: 500;
        }

        img {
            width: 20px;
            height: 20px;
            object-fit: contain;
            margin-right: 10px;
        }

        > div {
            margin-left: 10px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #C8C8C8;
            display: flex;
            align-items: center;
            justify-content: center;

            > div {
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }
        }
    }

    .check {
        
        > div {
            border: 1px solid #7D8BEC;

            > div {
                background: #7D8BEC;
            }
        }
    }

    .textarea {
        padding-bottom: 10px;
        flex-direction: column;
        align-items: flex-start;

        textarea {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-width: 0px;
            background: #F8F8F8;
            resize:none;
            font-size: 14px;
            color: #333;
        }
    }

    .noline {
        border-bottom: 0px;
    }
}

.footerBox {
    height: 60px;
}

.footer {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    position: fixed;
    background: #fff;
    align-items: center;
    box-sizing: border-box;

    p {
        padding: 0 15px;
        flex: 1;
        font-size: 12px;
        color: #333;

        span {
            font-size: 14px;
            color: #EF1400;
        }
    }

    div {
        width: 180px;
        height: 100%;
        background: linear-gradient(226deg,#9cb2f4, #6472e8 100%);
        border-radius: 3px 0px 0px 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #fff;
    }
}
</style>